import { Flex } from "@/atoms"
import { StatusSwitcherCell } from "@/molecules/StatusSwitcherCell"
import { StatusTag } from "@/molecules/StatusTag"
import { getAiPolicyStatus } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"

import type { TFunction } from "@/hooks/useTranslation"
import type { Record } from "@/pages/GovernancePage/applications/policies/getDemoData.types"
import type { PolicyRecordInput } from "@/pages/GovernancePage/applications/policies/useAiPolicies.types"

export interface StatusAiPolicyCellProps {
  isEnabled: (record: PolicyRecordInput) => boolean
  onChange: (enabled: boolean, record: PolicyRecordInput) => void
  // While a change saves, as the SCM policies' switches
  disabled: boolean
  noPermissions?: boolean
}

// Whether a real policy is on, switched in place as an SCM policy is. One that
// is on but has no agent to enforce on says so beside its switch.
export const StatusAiPolicyCell = (
  t: TFunction,
  props: StatusAiPolicyCellProps
) =>
  function StatusAiPolicyCellComponent(_: unknown, record: Record) {
    if (record.type === "heading" || !record.live) return null

    const enabled = props.isEnabled(record)
    const switcher = StatusSwitcherCell<PolicyRecordInput>(
      props.disabled || !!props.noPermissions,
      props.onChange,
      props.noPermissions
    )(enabled, record)
    const { status, key } = getAiPolicyStatus({ ...record.live, enabled })

    if (!enabled || status !== "warning") return switcher

    const tKey = `governance.ai.live.statuses.${key}`

    return (
      <Flex align="center" gap={8} wrap="wrap">
        {switcher}
        <StatusTag
          status="warning"
          text={t(`${tKey}.label`)}
          tooltip={t(`${tKey}.help`)}
        />
      </Flex>
    )
  }
